import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RoutesPath } from "../../app/BrowserRouter";
import "@aws-amplify/ui-react/styles.css";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectOfficer, setChapter } from "../../features/chapter/slice";
import {
  selectMember,
  selectUserEmail,
  setMember,
} from "../../features/member/slice";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { isNull } from "lodash";

function PageNavBar() {
  const dispatch = useDispatch();
  const { signOut } = useAuthenticator((context) => [context.user]);
  const userEmail = useSelector(selectUserEmail);
  const isOfficer = useSelector(selectOfficer(userEmail));
  const isMember = !isNull(useSelector(selectMember));

  const handleSignOut = () => {
    dispatch(setChapter(null));
    dispatch(setMember(null));
    signOut();
  };

  return (
    <Navbar expand="lg" variant="dark" bg="primary">
      <Container>
        <Navbar.Brand href="/">SMC AGS</Navbar.Brand>
        <Navbar.Text>{userEmail} </Navbar.Text>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/">
              Dashboard
            </Nav.Link>
            {!isMember && (
              <Nav.Link as={Link} to={`/${RoutesPath.SIGNUP}`}>
                Signup
              </Nav.Link>
            )}
            {isOfficer && (
              <Nav.Link as={Link} to={`/${RoutesPath.SEARCH}`}>
                Search
              </Nav.Link>
            )}

            <Nav.Link as={Link} onClick={handleSignOut} to={`/`}>
              Sign-out
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default PageNavBar;
